import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

import { Tooltip, tooltipClasses } from "scmp-app/components/common/tooltip";

export const StyledTooltip = styled(Tooltip)`
  & .${tooltipClasses.tooltip} {
    background-color: #001246;
  }

  & .${tooltipClasses.arrow} {
    color: #001246;
    font-size: 20px;
  }
`;

export const MessageContainer = styled.div`
  display: grid;
  grid:
    "badge . close" min-content
    "message message message" min-content
    / min-content auto 10px;
  gap: 4px;

  inline-size: 225px;
  padding: 10px;
`;

export const NewBadge = styled.div`
  grid-area: badge;

  display: inline-block;

  inline-size: fit-content;
  padding-block: 3px;
  padding-inline: 2px;

  color: #ffffff;
  white-space: nowrap;

  border-radius: 4px;

  background-color: #eb4254;
`;

export const Message = styled.div`
  grid-area: message;

  color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
`;

export const CloseButton = styled.button`
  grid-area: close;

  display: inline-block;

  background-color: transparent;

  cursor: pointer;
`;
